$(function () {
  // contact page

  $('body.contacts form#contacts').on('submit', function (e) {
    e.preventDefault()
    var form = $(this)
    form.parent().find('.msg').html('')
    doAjaxPost(
      form.attr('action'),
      form.serialize(),
      function (response) {
        console.log('contact response', response)
        if (response === 'error email') {
          form.parent().find('.msg').append(`<div class="error"><div>${i18next.t('contact.email-is-required')}</div></div>`)
        } else if (response === 'error text') {
          form.parent().find('.msg').append(`<div class="error"><div>${i18next.t('contact.message-is-required')}</div></div>`)
        } else if (response === 'ok') {
          form.parent().find('.msg').append(`<div class="success"><div>${i18next.t('contact.message-was-sent')}</div></div>`)
          form.find('input, textarea').val('')
        } else {
          //showError();
        }
      },
      function () {
        //showError();
      }
    )
  })
})
